import React from 'react';
import { toUSD } from "../../util/currency-formatter";
import CustomTable from "../table/table";
import './breakdown.scss';

const SubcontractorCostsTable = ({ costDetails, handleViewPO, handleViewWO, handleViewInvoice }) => {
  const subcontractorColumns = [
    // { field: "type", title: "Type" },
    {
      field: "poNumber",
      title: "WO Number",
      render: (item) => (
        <span
          className="po-link"
          onClick={() => handleViewWO(item.poId)}
        >
          {/* procurementCode is the PO number with project prefix and Suffix if null then default to po Number*/}
          {item.procurementCode || item.poNumber}
        </span>
      )
    },
    {
      field: "invoiceNumber",
      title: "Invoice Number",
      render: (item) => (
        <span
          className="invoice-link"
          onClick={() => handleViewInvoice(item.invoiceNumber, item.invoiceData, item.invoiceId, true)}
        >
          {item.invoiceNumber}
        </span>
      )
    },
    { field: "contractorName", title: "Contractor" },
    { field: "date", title: "Date" },
    {
      field: "subTotal",
      title: "Amount",
      class: "text-right",
      render: (item) => <span className="text-right">{toUSD(item.subTotal)}</span>
    }
  ];

  const subcontractorData = costDetails.filter(item => item.type === 'Subcontractor Invoice');
  const subcontractorSubtotal = subcontractorData.reduce((sum, item) => sum + (item.subTotal || 0), 0);

  // Add subtotal row
  const subcontractorDataWithSubtotal = [...subcontractorData
    //     , {
    //     id: 'subcontractor-subtotal',
    //     type: '',
    //     poNumber: '',
    //     invoiceNumber: '',
    //     contractorName: '',
    //     date: '',
    //     subTotal: subcontractorSubtotal,
    //     isSubtotalRow: true
    //   }
  ];

  return (
    <div className="breakdown-container mt-3">
      <CustomTable
        columns={subcontractorColumns}
        data={subcontractorDataWithSubtotal}
        toolbar={true}
        exportButton={true}
        enableSearch={true}
        itemsPerPageCustom={false}
      />

      <div className="mt-3 border d-flex justify-content-between align-items-center p-2">
        <p className="mb-0 subtotal">Contractor Subtotal</p>
        <p className="mb-0 subtotal">{toUSD(subcontractorSubtotal)}</p>
      </div>
    </div>
  );
};

export default SubcontractorCostsTable; 